import { render, staticRenderFns } from "./FacialDeviceEditForm.vue?vue&type=template&id=1c31ef4a&scoped=true&"
import script from "./FacialDeviceEditForm.vue?vue&type=script&lang=js&"
export * from "./FacialDeviceEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c31ef4a",
  null
  
)

export default component.exports